/**
 * NOTE: These utils were copied from `src/packages/permissions-administration/pages/users-and-roles/src/common/utils/index.tsx`
 * to avoid a circular dependency between this package and that one. Remove these utils once the UI components using them
 * are no longer in this package.
 */

import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { multipleRolesText } from './messages';
import type { Actor, Role, RoleId } from './types';

export const getActorRoleIds = (actor: Actor): RoleId[] => actor.roles.map(({ id }): RoleId => id);

export const multipleRolesMessage = (intl: IntlShape, count: number): string =>
	intl.formatMessage(multipleRolesText.roleMessage, { count });

// This function comes from `src/packages/permissions-administration/pages/users-and-roles/src/common/ui/roles-picker/utils.tsx`
export const getRoleName = (roles: Role[], roleId: RoleId): string => {
	const role = roles.find((r) => roleId === r.id);
	return role?.translatedName || '';
};
